import type { PageContext } from "vike/types";
import type { BlogDetailData } from "./+data";

/**
 * Title fallback chain (per-article):
 *   1. `articles.seo_meta_title` — AI-written, SEO-tuned
 *   2. `articles.article_title`  — human-readable headline
 *   3. Derived from `article_slug` (Title Case, dashes → spaces) when both
 *      of the above are NULL/empty.
 */
const slugToTitle = (slug: string): string =>
  slug
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const title = (pageContext: PageContext): string => {
  const data = pageContext.data as BlogDetailData | undefined;
  const site = pageContext.siteConfig;
  const fallback = site?.defaultTitle ?? "panduankafe.com";

  if (!data?.article) return fallback;

  const { seo_meta_title, article_title, article_slug } = data.article;
  return (
    seo_meta_title?.trim() ||
    article_title?.trim() ||
    slugToTitle(article_slug) ||
    fallback
  );
};
